module.exports = __webpack_public_path__ + "img/aca_1.9dd50005.png";